// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"c8ead424","238":"2a2c8334","328":"233de914","434":"aafe1aa5","593":"59167b70","632":"ca0a958c","662":"183fe25f","850":"19261321","893":"ce35a1d9"}[chunkId] + ".chunk.js";
};